@if (currentSection === 'releaseNotes') {
<div class="py-200-rem px-250-rem h-full">
  <div class="flex flex-col space-y-050-rem">
    <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Release notes</h1>
    <p class="text-container-fg-muted text-label-md-weight-regular">
      Paste a JSON object that conforms to the schema below. Use BCF-47 language codes.
    </p>
  </div>
  <div
    class="px-150-rem mt-100-em rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-6 flex flex-col">
    <h2 class="text-container-fg-default text-headline-sm-weight-medium py-050-em">JSON input</h2>
    <div>
      <div>
        <div>
          <div>
            <form [formGroup]="releaseNotesForm">
              <mat-form-field
              [class.error-textarea]="error"
                class="w-full border border-none"
                appearance="outline"
                >
                <textarea
                  matInput
                  formControlName="notes"
                  placeholder="{{jsonExample}}"
                  name="releaseNotes"
                  rows="16"></textarea>
              </mat-form-field>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
          @if(error) {
           <div class="flex items-center text-label-sm-weight-regular text-feedback-fg-error mt-050-em">
      <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
      <code class="whitespace-pre-wrap text-label-sm-weight-regular"> {{ error }} </code>
    </div> 
      }
</div>
}